export const reportSelector = (state) => state.reports.report;
export const reportLoadingSelector = (state) => state.reports.loading;
export const columnsSelector = (state) => state.reports.columns;
export const totalSelector = (state) => state.reports.total;
export const placesSelector = (state) => state.reports.places;
export const employeesSelector = (state) => state.reports.employees;
export const jobTypesSelector = (state) => state.reports.jobTypes;
